/* tslint:disable */
 
import { ActionInfo } from './action-info';
import { ReferenceProperty } from './reference-property';

/**
 * (tsType: DataEntryHistory, schemaOptions: { includeRelations: false })
 */
export class DataEntryHistory {
  actionInfo: ActionInfo;
  additionalData?: any;
  historyType: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
  id?: string;

  /**
   * The reason why the entry is invalid
   */
  invalidReason?: 0 | 1;
  isInvalid?: boolean;
  isValueResolved?: boolean;
  relatedTo: ReferenceProperty;
  specificationVersion: number;
}
